
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { User, ClassGroup } from '../types';
import { db } from '../services/db';
import { GlobalLoader } from '../components/GlobalLoader';
import { StoreFront } from '../components/StoreFront';

export const StoreRoute = () => {
  const { slug } = useParams<{ slug: string }>();
  const [storeData, setStoreData] = useState<{student: User, classInfo: ClassGroup} | null | undefined>(undefined);

  useEffect(() => {
    if (slug) {
        // Use the SECURE RPC call to fetch public student info
        db.getStoreData(slug).then(result => {
            if (result && result.student) {
                setStoreData(result);
                // Egen besöksstatistik: ett besök per gång butiken öppnas. Inga cookies, inget om besökaren.
                db.recordStoreVisit(slug);
            } else {
                setStoreData(null);
            }
        }).catch(() => setStoreData(null));
    } else {
        setStoreData(null);
    }
  }, [slug]);

  if (storeData === undefined) return <GlobalLoader message="Hämtar butik..." />;

  if (!storeData) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-coffee-50 p-4 text-center">
        <h1 className="text-3xl font-black text-coffee-800 mb-2">Hoppsan!</h1>
        <p className="text-gray-600 mb-6 font-medium">Vi kunde inte hitta säljsidan du söker. Kontrollera länken.</p>
        <a href="/" className="px-6 py-3 bg-coffee-600 text-white text-sm font-black rounded-xl hover:bg-coffee-700 transition shadow-lg uppercase tracking-widest">Till startsidan</a>
      </div>
    );
  }

  return <StoreFront student={storeData.student} schoolClass={storeData.classInfo} />;
};
